export default "__VITE_ASSET__2580122e__"